import { StoreState } from 'client/store'
import { PuzzleType } from 'client/types/PuzzleType'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const usePuzzleType = (puzzleTypeId: number): PuzzleType | undefined => {
  const puzzleTypes = useSelector<StoreState, PuzzleType[]>((state) => state.puzzleData?.puzzleTypes)
  return useMemo(() => puzzleTypes?.find((pT) => pT.puzzleTypeId === puzzleTypeId), [puzzleTypeId, puzzleTypes])
}

export default usePuzzleType
